import expenseBreakdown from '../json/expense_breakdown.json';
import outOfPocketHealthExpense from '../json/out_of_pocket_health.json';
import regionalTransportation from '../json/regional_transportation_expenses.json';
import housingExpenses from '../json/housing_expenses.json';
import taxBrackets from '../json/tax_brackets.json'
import standardDeduction from '../json/standard_deductions.json'
import { getMedianIncome } from '../consultation';
import districtData from '../json/district_divisions_counties.json';
// JSON mapping of districts to admin expense multipliers by state
import adminData from '../json/nested_county_district_admin_expense.json';
const STATE_NAMES = {
    AL: 'Alabama',        AK: 'Alaska',       AZ: 'Arizona',
    AR: 'Arkansas',       CA: 'California',   CO: 'Colorado',
    CT: 'Connecticut',    DE: 'Delaware',     FL: 'Florida',
    GA: 'Georgia',        HI: 'Hawaii',       ID: 'Idaho',
    IL: 'Illinois',       IN: 'Indiana',      IA: 'Iowa',
    KS: 'Kansas',         KY: 'Kentucky',     LA: 'Louisiana',
    ME: 'Maine',          MD: 'Maryland',     MA: 'Massachusetts',
    MI: 'Michigan',       MN: 'Minnesota',    MS: 'Mississippi',
    MO: 'Missouri',       MT: 'Montana',      NE: 'Nebraska',
    NV: 'Nevada',         NH: 'New Hampshire',NJ: 'New Jersey',
    NM: 'New Mexico',     NY: 'New York',     NC: 'North Carolina',
    ND: 'North Dakota',   OH: 'Ohio',         OK: 'Oklahoma',
    OR: 'Oregon',         PA: 'Pennsylvania', RI: 'Rhode Island', PR:"Puerto Rico",
    SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee',
    TX: 'Texas',          UT: 'Utah',         VT: 'Vermont',
    VA: 'Virginia',       WA: 'Washington',   WV: 'West Virginia',
    WI: 'Wisconsin',      WY: 'Wyoming',      DC: 'District of Columbia'
  };
function calculateAge(dob) {
    if (!dob) return 0;
    const birth = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  }
  

export function computeDisposableIncome(answers) {
    const householdSize =
        1 +
        (answers.maritalStatus === 'married' ? 1 : 0) +
        (answers.dependentDetails?.length || 0);
    // 1. Gross income
  
    // 2. household expenses
    const food          = expenseBreakdown['Food'][householdSize]
    const housekeeping  = expenseBreakdown['Housekeeping supplies'][householdSize]
    const apparel       = expenseBreakdown['Apparel & services'][householdSize]
    const personalCare  = expenseBreakdown['Personal care products & services'][householdSize]
    const miscellaneous = expenseBreakdown['Miscellaneous'][householdSize]

    const foodClothingAndOther = food + housekeeping + apparel + personalCare + miscellaneous;
    //console.log("Food and other: " + foodClothingAndOther)
    const fivePercentAdditionalFood = (food + apparel) * .05;


    // 3. Out of Pocket Helathcare expenses
    const healthYoung = outOfPocketHealthExpense['under_65'];
    const healthOld = outOfPocketHealthExpense['65_and_older'];

    let under65Count = 0;
    // respondent
    if (calculateAge(answers.dob) <= 65) under65Count++;
    // spouse
    if (answers.maritalStatus === 'married') {
      const sDob = answers.spouseDOB || answers.dob;
      if (calculateAge(sDob) <= 65) under65Count++;
    }
    // dependents
    answers.dependentDetails.forEach(dep => {
      if (dep.age <= 65) under65Count++;
    });
  
    const healthCosts = (under65Count * healthYoung) + ((householdSize - under65Count) * healthOld);
  
    // 4. Housing and Utility Expenses
    const sizeKey = householdSize >= 6 ? '5' : String(householdSize);
    let fipsCode = String(answers.censusTract['STATE']) + String(answers.censusTract['COUNTY']);
    //console.log(fipsCode)
    let nonMortgageExpense = 0;
    let mortgageExpense    = 0;
    
    // Derive your two-letter state abbreviation (from the form)
    const stateAbbr = answers.state?.toUpperCase() || '';
    const counties  = housingExpenses[stateAbbr] || [];
    
    let county = ''
    // 1) Try exact match
    let countyEntry = counties.find(c => c.fips === fipsCode);
    
    // 2) If not found, find the “nearest” by numeric difference
    if (!countyEntry && counties.length) {
      const target = parseInt(fipsCode, 10);
      let bestDiff = Infinity;
      for (const c of counties) {
        const diff = Math.abs(parseInt(c.fips, 10) - target);
        if (diff < bestDiff) {
          bestDiff = diff;
          countyEntry = c;
        }
      }
    }
    
    if (countyEntry) {
      // Normalize county name by removing common suffixes
      const rawCounty = countyEntry.county;
      county = rawCounty.replace(/\s*(County|Parish|Municipality|Borough)\b/i, '').trim();
      const band = countyEntry.expenses[sizeKey] || {};
      nonMortgageExpense = band.non_mortgage ?? 0;
      mortgageExpense    = band.mortgage     ?? 0;
    }
    const actualMortgageExpense = Number(answers.mortgageMonthlyPayment) + Number(answers.secondMortgageMonthlyPayment)
    mortgageExpense = Math.max(mortgageExpense,actualMortgageExpense)
    
    //console.log(
    //  `mortgage expense: ${mortgageExpense}\n` +
   //   `nonmortgage expense: ${nonMortgageExpense}`
  //  );

    //console.log(county)
    
    // 5. Transportation Expenses
    // Determine the region based on the debtor's state.
    const stateName = STATE_NAMES[stateAbbr] || answers.state || '';
    //console.log(stateName)
    // Find the region entry in the JSON data
    const regionEntry = Object.values(regionalTransportation).find(r =>
      r.states.includes(stateName)
    );
    let transportationExpense = 0;
    // Determine vehicle count (vehicles + spouseVehicles)
    const vehicleCount = (answers.vehicles?.length || 0) + (answers.spouseVehicles?.length || 0);
    if (vehicleCount === 0)
    {
        transportationExpense = regionEntry.public_transportation
    }
    else{

    
        const carKey = vehicleCount <= 1 ? 'one_car' : 'two_cars';

        let operatingCost = 0;
        let ownershipCost = 0;
        if (regionEntry) {
        const countyName = county;
        const msaList = regionEntry.operating_costs.msa;
        const msaMatch = Object.values(msaList).find(msa =>
            msa.counties.includes(countyName)
        );
        if (msaMatch) {
            operatingCost = msaMatch[carKey];
        } else {
            operatingCost = regionEntry.operating_costs.region[carKey];
        }
        ownershipCost = regionEntry.ownership_costs[carKey];
        }
        //console.log(operatingCost)
        //console.log(ownershipCost)
        transportationExpense = operatingCost + ownershipCost;
    }
    console.log(`transportation expense: ${transportationExpense}`);

    //// tax calculation
    let grossIncome = 0;
    ///here calculating the tax income from:
    let payrollTax = 0;
    let preTax401k = 0;
    let preTaxHealthCare = 0;
    ////start with payroll taxes like medicare and social security
    if (answers.employmentStatus === 'yes'){
        if (answers.payType === 'self-employed')
        {
            grossIncome += Number(answers.NetProfit)
            payrollTax += answers.netProfit * .153
        }
        else if (answers.payType === 'salary'){
            if (answers.deductions.includes('401k')){
                preTax401k += answers.yearlySalary * .05 / 12
            }
            grossIncome += answers.yearlySalary / 12
            payrollTax += answers.yearlySalary * .0765 / 12
        }
        else {
            if (answers.deductions.includes('401k')){
                preTax401k += answers.hourlyRate * answers.hoursWorked * .05 * 52 /12
            }
            grossIncome += answers.hourlyRate * answers.hoursWorked * 52 /12
            payrollTax += answers.hourlyRate * answers.hoursWorked * 52 * .0765 /12
        }
        if (answers.deductions.includes('insurance')){
            preTaxHealthCare += householdSize * 125;
        }
        if (answers.secondJob === 'yes'){
            if (answers.secondPayType === 'self-employed')
            {
                grossIncome += Number(answers.secondNetProfit)
                payrollTax += answers.secondNetProfit * .153
            }
            else if (answers.secondPayType === 'salary'){
                grossIncome += answers.secondYearlySalary / 12
                payrollTax += answers.secondYearlySalary * .0765 / 12
            }
            else {
                grossIncome +=answers.secondHourlyRate * answers.secondHoursWorked * 52 /12
                payrollTax += answers.secondHourlyRate * answers.secondHoursWorked * 52 * .0765 /12
            }
        }
    }
    if (answers.maritalStatus === 'married'){
        if (answers.spouseEmploymentStatus === 'yes'){
            if (answers.spousePayType === 'self-employed')
            {
                grossIncome += Number(answers.spouseNetProfit)
                payrollTax += answers.spouseNetProfit * .153
            }
            else if (answers.spousePayType === 'salary'){
                if (answers.spouseDeductions.includes('401k')){
                    preTax401k += answers.spouseYearlySalary * .05 / 12
                }
                grossIncome += answers.spouseYearlySalary/12
                payrollTax += answers.spouseYearlySalary * .0765 / 12
            }
            else {
                if (answers.spouseDeductions.includes('401k')){
                    preTax401k += answers.spouseHourlyRate * answers.spouseHoursWorked * .05 * 52 /12
                }
                grossIncome += answers.spouseHourlyRate * answers.spouseHoursWorked * 52 /12
                payrollTax += answers.spouseHourlyRate * answers.spouseHoursWorked * 52 * .0765 /12
            }
            if (answers.spouseDeductions.includes('insurance')){
                preTaxHealthCare += householdSize * 125;
            }
            if (answers.spouseSecondJob === 'yes'){
                if (answers.spouseSecondPayType === 'self-employed')
                {
                    grossIncome += Number(answers.spouseSecondNetProfit)
                    payrollTax += answers.spouseSecondNetProfit * .153
                }
                else if (answers.spouseSecondPayType === 'salary'){
                    grossIncome += answers.spouseSecondYearlySalary / 12
                    payrollTax += answers.spouseSecondYearlySalary * .0765 / 12
                }
                else {
                    grossIncome += answers.spouseSecondHourlyRate * answers.spouseSecondHoursWorked * 52 /12
                    payrollTax += answers.spouseSecondHourlyRate * answers.spouseSecondHoursWorked * 52 * .0765 /12
                }
            }
        }
    }
    preTaxHealthCare = Math.min(preTaxHealthCare, 750)
    const grossTaxableIncome = grossIncome - payrollTax - preTax401k - preTaxHealthCare
    //console.log(`gross income: ${grossIncome}`)
    //console.log(`payroll tax: ${payrollTax}`)
    //console.log(`401k Contributions: ${preTax401k}`)
    //console.log(`Healthcare: ${preTaxHealthCare}`)
    //console.log(`taxableIncome: ${grossTaxableIncome}`)
    let taxStatus = "Single"
    if (answers.maritalStatus == "married") {
        taxStatus = "Married Filing Jointly"
    }
    else if (answers.dependents.length > 0 && answers.childSupport === 'no'){
        taxStatus = "Head of Household"
    }
    //console.log(taxStatus)
    const rawDeduction = standardDeduction[taxStatus]; 
    const standardDeductionValue = Number(rawDeduction.replace(/[$,]/g, '')); 
    const adjustedGrossIncome = (grossTaxableIncome * 12) - standardDeductionValue
    //console.log("AGI: " + adjustedGrossIncome)
    let yearlyIncomeTax = 0;
    const agi = adjustedGrossIncome; // AGI is already annual
    const brackets = taxBrackets[taxStatus] || [];
    let tax = 0;


    for (const bracket of brackets) {
    // parse the lower bound of this bracket
    const lower = Number(bracket.start.replace(/[$,]/g, ''));
    // parse the upper bound, or Infinity if it's "And up"
    const upper = bracket.end === 'And up'
        ? Infinity
        : Number(bracket.end.replace(/[$,]/g, ''));

    if (agi > lower) {
        // how much of your AGI falls into this bracket
        const taxableInBracket = Math.min(agi, upper) - lower;
        // convert "10%" → 0.10
        const rate = parseFloat(bracket.rate) / 100;
        tax += taxableInBracket * rate;
    }
    }

    yearlyIncomeTax = tax;
    //console.log(`Yearly Income Tax: ${yearlyIncomeTax}`);
    const monthlyFederalIncomeTax = yearlyIncomeTax / 12
    //console.log("monthly tax = " + monthlyFederalIncomeTax)
    const inflationCalculation = .05
    const yearsSince2025 = new Date().getFullYear() - 2025;
    const extraExpenses = 300 * yearsSince2025 * inflationCalculation + 300;
    const courtPayments = Number(answers.childSupportAmount) + Number(answers.alimonyAmount) + Number(answers.spouseChildSupportAmount) + Number(answers.spouseAlimonyAmount);
    //console.log("court payments: "+courtPayments)
    // include in breakdown and total
    preTaxHealthCare = Math.max(preTaxHealthCare,200);
    const totalDeductionsLessTrustee =
      foodClothingAndOther + fivePercentAdditionalFood + healthCosts + courtPayments +
      nonMortgageExpense + mortgageExpense + transportationExpense + payrollTax + preTax401k + preTaxHealthCare + monthlyFederalIncomeTax + extraExpenses;
      const fips = answers.censusTract.STATE + answers.censusTract.COUNTY
      console.log("fips: " + fips)
      
  
      // look up district based on the fips code
    const district = Object.keys(districtData).find(
    key => districtData[key].counties && districtData[key].counties[fips]
    );
    console.log('District for fips', fips, 'is', district);
    // derive admin expense multiplier key as uppercase district code without trailing letter
    const adminKey = district ? district.toUpperCase().slice(0, -1) : null;
    let adminExpenseMultiplier = null;
    if (adminKey) {
    // search each state section for our district code key
    for (const stateName of Object.keys(adminData)) {
        const stateSection = adminData[stateName];
        if (stateSection && stateSection[adminKey]) {
        adminExpenseMultiplier = stateSection[adminKey].admin_expense_multiplier;
        break;
        }
    }
    }
    console.log('Admin expense multiplier for district', district, 'is', adminExpenseMultiplier);
    const trusteeFactor = (adminExpenseMultiplier/100)
    console.log("trustee factor: " + trusteeFactor)
    //console.log("gross income: " + grossIncome)
    const trusteeExpense = Math.max(((grossIncome - totalDeductionsLessTrustee) * trusteeFactor),0);
    const totalDeductions = totalDeductionsLessTrustee + trusteeExpense;
    //console.log ("total deductions: " + totalDeductions)
    let fixedIncome = 0;
    for (const key in answers.fixedIncomeDetails) {
      const raw = answers.fixedIncomeDetails[key];
      const str = raw != null && typeof raw !== 'number'
        ? String(raw)
        : raw != null
        ? raw.toString()
        : '';
      const cleaned = str.replace(/,/g, '');
      const num = raw != null && typeof raw === 'number'
        ? raw
        : parseFloat(cleaned) || 0;
      fixedIncome += num;
    }
    let spouseFixedIncome = 0;
    for (const key in answers.spouseFixedIncomeDetails) {
      const raw = answers.spouseFixedIncomeDetails[key];
      const str = raw != null && typeof raw !== 'number'
        ? String(raw)
        : raw != null
        ? raw.toString()
        : '';
      const cleaned = str.replace(/,/g, '');
      const num = raw != null && typeof raw === 'number'
        ? raw
        : parseFloat(cleaned) || 0;
      spouseFixedIncome += num;
    }
    const disposableIncome = grossIncome + fixedIncome + spouseFixedIncome - totalDeductions
   // console.log("disposable income: " + disposableIncome)
    return {
      disposableIncome,
      breakdown: {
        grossIncome,
        fixedIncome,
        spouseFixedIncome,
        county,
        fipsCode,
        foodClothingAndOther,
        fivePercentAdditionalFood,
        healthCosts,
        nonMortgageExpense,
        preTax401k,
        preTaxHealthCare,
        mortgageExpense,
        actualMortgageExpense,
        transportationExpense,
        extraExpenses,
        courtPayments,
        monthlyFederalIncomeTax,
        payrollTax,
        trusteeExpense,
        totalDeductionsLessTrustee,
        totalDeductions,
        householdSize
      }
    };
  }